export default __webpack_public_path__ + "img/d273b4348e124e2ecbc8c7ff5d0017de.png";